import './Main.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ProductosMain from '../../Components/Admin/ProductosMain/ProductosMain';
import PedidosMain from '../../Components/Admin/PedidosMain/PedidosMain';
import UsuariosMain from '../../Components/Admin/UsuariosMain/UsuariosMain';
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad';
import InfoUserMain from '../../Components/Admin/InfoUserMain/InfoUserMain';
import GraficoPedidos from '../../Components/Admin/Graficos/GraficoPedidos';
import GraficoProductos from '../../Components/Admin/Graficos/GraficoProductos';

export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />

                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <ProductosMain />
                    </div>

                    <div className='graficosFlex'>
                        <GraficoPedidos />
                        <GraficoProductos />
                    </div>

                    <div className='deFLexMain'>
                        <UsuariosMain />
                        <InfoUserMain />
                    </div>
                </div>

                <PedidosMain />
            </section>
        </div>
    );
}